import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import AvatarChip from '../../../../shared/avatar-chip';
import { getDecomSuspendedUsers, UserKeys } from '../../../../api/users-api';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { DecomSuspendedUserModel } from '../../../../../types';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';

export function UserFilter(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const userId = searchParams.get('userId');

  const { data: decomSuspendedUsers } = useQuery({
    queryKey: [UserKeys.SuspendedUsers],
    queryFn: () => getDecomSuspendedUsers(),
    meta: {
      errorMessage:
        'There was an issue loading the suspended users. Please refresh and try again.',
    },
  });

  const filteredUser =
    decomSuspendedUsers?.find(
      (suspendedUser) => suspendedUser.userId === userId
    ) || null;

  const handleFilterChange = (newValue: DecomSuspendedUserModel) => {
    setSearchParams({ userId: newValue.userId });
    applyValue({ ...item, value: newValue.userId });
  };

  return (
    <Box
      sx={{
        width: 300,
        position: 'relative',
        top: item.value ? 0 : -10,
        left: item.value ? 4 : 0,
      }}
    >
      {item.value ? (
        <AvatarChip
          type="User"
          email={filteredUser?.email || ''}
          onDelete={() => {
            searchParams.delete('userId');
            setSearchParams(searchParams);
            applyValue({ ...item, value: '' });
          }}
        />
      ) : (
        <Autocomplete
          size="medium"
          options={decomSuspendedUsers || []}
          autoComplete
          autoHighlight
          noOptionsText="No Users Found"
          sx={{ width: 400 }}
          value={filteredUser || null}
          onChange={(_event, newValue) => {
            if (newValue) {
              handleFilterChange(newValue);
            }
          }}
          renderInput={(params) => (
            <TextField {...params} label="Search for a user" fullWidth />
          )}
          getOptionLabel={(option: DecomSuspendedUserModel) => option.email}
          isOptionEqualToValue={(
            option: DecomSuspendedUserModel,
            value: DecomSuspendedUserModel
          ) => option.email === value?.email}
          renderOption={(props, option: DecomSuspendedUserModel) => {
            return (
              <ListItem {...props} dense>
                <ListItemText
                  id={option.email}
                  primary={option.email}
                  secondary={`User ID: ${option.userId}`}
                />
              </ListItem>
            );
          }}
        />
      )}
    </Box>
  );
}
